export default {
  setData({ commit }, payload) {
    const {
      data: {
        project: {
          id: projectId
        }
      },
      system: {
        sortGroup: boardConfig,
        taskFields
      }
    } = payload;
    commit('setProjectId', projectId);
    commit('setBoardConfigs', {
      [projectId]: boardConfig
    });
    commit('setAllFields', taskFields);
  },
}
